import { render, staticRenderFns } from "./LandingHero.vue?vue&type=template&id=4d187f06&scoped=true"
import script from "./LandingHero.vue?vue&type=script&lang=ts"
export * from "./LandingHero.vue?vue&type=script&lang=ts"
import style0 from "./LandingHero.vue?vue&type=style&index=0&id=4d187f06&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d187f06",
  null
  
)

export default component.exports